import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTypography = styled(Typography)(({ theme }) => ({}));

export { PeekTypography, PeekTypography as default };
